
import React, { Component } from 'react';
import './wrong-answers-modal.scss'
import { Modal, ModalBody } from "reactstrap";
import HomeworkApi from '../../../apis/homework'
import TestApi from '../../../apis/test'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';
import Latex from "react-latex";
import { InlineMath, BlockMath } from 'react-katex'
import MathJax from "react-mathjax2"
import CwContentViewer from '../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../common/canvas/canvas'
import GeometryTranspiler from '../../common/geometry/geometry-parser'
// import WronglyAnsweredUsers from './wrongly-answered-users/wrongly-answered-users';


class AddContactComponent extends Component {
    constructor(props) {
        super(props)

    }

    state = {
        showOptions: true,

        wrongAnswers: [],
        wrongAnswersOfallUsers: [],
        selectedIndex: -1,
        selectedPercentage: 0
    }

    componentDidMount() {
        if (this.props.selectedStatus) {
            this.getStatusWiseWrongAnswers()
        } else {
            this.getWrongAnswers();
        }
    }

    getWrongAnswers() {
        if (this.props.type == "TEST") {
            this.getTestWrongAnswer()
        } else {
            this.getHomeworkWrongAnswer()
        }
    }

    getHomeworkWrongAnswer(payload = {}) {

        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem._id
        }

        HomeworkApi.getHomeworkWrongAnswersReport(payload)
            .then(response => {

                console.log("response", response)
                let wrongAnswersHash = {}

                let result = response.result
                for (let i = 0; i < result.length; i++) {

                    wrongAnswersHash[result[i].percentage] = [result[i]]

                }
                this.setState({ wrongAnswers: result, wrongAnswersHash, wrongAnswersOfallUsers: result, basePath: response.basePath })

            }).catch(err => {
            })
    }


    getTestWrongAnswer(payload = {}) {

        if (this.props.selectedItem) {
            payload.testId = this.props.selectedItem._id
        }
        if (this.props.usersId) {
            payload.usersId = this.props.usersId
        }

        TestApi.getTestWrongAnswersReport(payload)
            .then(response => {

                console.log("response", response)
                let wrongAnswersHash = {}

                let result = response.result
                for (let i = 0; i < result.length; i++) {

                    wrongAnswersHash[result[i].percentage] = [result[i]]

                }
                this.setState({ wrongAnswers: result, wrongAnswersHash, wrongAnswersOfallUsers: result, basePath: response.basePath })

            }).catch(err => {
            })
    }

    getStatusWiseWrongAnswers = () => {

        if (this.props.type == "TEST") {
            this.getTestWrongAnswer()
        } else {
            this.getHomeworkStatusWiseWrongAnswers()
        }
    }
    getHomeworkStatusWiseWrongAnswers(payload = {}) {

        if (this.props.selectedStatus) {
            payload.status = this.props.selectedStatus
            payload.userIds = this.props.userIds
            payload.homeworkId = this.props.homeworkId
        }

        HomeworkApi.getHomeworkStatusWrongAnswersReport(payload)
            .then(response => {

                let wrongAnswersHash = {}

                let result = response.result
                for (let i = 0; i < result.length; i++) {

                    wrongAnswersHash[result[i].percentage] = [result[i]]

                }
                console.log("response", response)
                this.setState({ wrongAnswers: result, wrongAnswersHash, wrongAnswersOfallUsers: result, basePath: response.basePath })

            }).catch(err => {
            })
    }


    createElementFromHTML = (html) => {
        var template = document.createElement('template');
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        return template.content.firstChild;
    }

    getCanvasSize(coordinates = []) {
        if (!coordinates) return {}
        let maxHeight = 0, maxWidth = 0
        for (let i = 0; i < coordinates.length; i++) {
            for (let j = 0; j < coordinates[i].points.length; j++) {
                if (maxWidth < coordinates[i].points[j].x) {
                    maxWidth = coordinates[i].points[j].x
                }
                if (maxHeight < coordinates[i].points[j].y) {
                    maxHeight = coordinates[i].points[j].y
                }
            }
        }
        return { maxHeight, maxWidth }
    }

    renderContentType = (contentType, content) => {

        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2 '>
                                        <div className='radio-btn'></div>
                                    </div>
                                    <div className='col 6'>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 2:
                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2 '>
                                        <div className='check-box'></div>
                                    </div>
                                    <div className='col 6'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 4:
                return (

                    <div>
                        <div className='row'>
                            {content.content.options.map((item, index) =>
                                <div className='col-2 matching-option'>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        // <div className='match-option' dangerouslySetInnerHTML={{ __html: item.answer.content }} />
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-2 ml-2 row sequence-option'>
                                    <div className='col-2'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col 6 '>{item.contentTypeName == 'TEXT' ?
                                        // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div>
                        <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-2'> {item.contentTypeName == 'TEXT' ?
                                    // <div className='group-items' dangerouslySetInnerHTML={{ __html: item.content }} />
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div>
                        <div className='row mt-4'>
                            {content.content.options.map((item, index) =>
                                <div className='ml-2 group-option'>
                                    <div className='group-header px-3'>
                                        {/* <div className='text-center mt-2' dangerouslySetInnerHTML={{ __html: item.title }} /> */}
                                        <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                )

            case 10:
                if (content && content.content && content.content.canvas && content.content.canvas.render && content.content.canvas.render.script && content.content.canvas.render.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return ("")
        }

    }

    onClickPercentage = (item, index) => {

        if (index == this.state.selectedIndex) {
            this.setState({ selectedPercentage: '', wrongAnswers: this.state.wrongAnswersOfallUsers, selectedIndex: -1, showStudents: false })
        } else {
            this.setState({ selectedPercentage: item.percentage, selectedIndex: index, wrongAnswers: this.state.wrongAnswersHash[item.percentage], showStudents: false })
        }
    }

    viewStudents = (item) => {
        this.setState({ showStudents: true, students: item.users })
        // alert('test')
    }

    closeStudents = () => {
        this.setState({ showStudents: false, students: [] })
    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideReport && this.props.delegate.hideReport()
    }


    render() {
        return (
            <>

                    

                    <div className="wrong-answers-modal">

                        <div className='mb-5'>
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>

                        <span className='screen-title'>Most Wrongly Answered</span>

                        {this.state.showStudents ?
                            <div className='mr-5 students-card'>

                                <div className="row">
                                    <div className="col">
                                        <img className="close-icon cursor-pointer" onClick={this.closeStudents} src={getImageSource(ImageConstants.CROSS)} />
                                    </div>
                                </div>

                                {
                                    this.state.students && this.state.students.length ? this.state.students.map((item, index) =>
                                        <div className='px-4 py-2 row align-items-center'>
                                            <div className="profile-avatar text-center mr-2 d-inline-block">
                                                <div className="row justify-content-center">
                                                    {item.image ? <img className="" alt="img" src={`${this.state.basePath}${item.image}`} />
                                                        :
                                                        <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                                                </div>
                                            </div>
                                            <div className='student-name ml-2'>
                                                {item.name}
                                            </div>
                                        </div>

                                    )
                                        :
                                        ""
                                }
                            </div>
                            :
                            ""
                        }

                        <div className='ml-3 mt-4 row'>
                            {this.state.wrongAnswersOfallUsers.length && this.state.wrongAnswersOfallUsers.length > 1 ? this.state.wrongAnswersOfallUsers.map((item, index) =>

                                <div className={this.state.selectedIndex == index ? 'selected-percentage-container cursor-pointer' : 'percentage-container cursor-pointer'} onClick={() => this.onClickPercentage(item, index)}>
                                    <div className={this.state.selectedIndex == index ? 'selected-percentage-text' : 'percentage-text'}>{item.percentage} % Students</div>
                                </div>
                            )
                                :
                                <></>}
                        </div>

                        <div className="wrong-answers-modal-max-height ">
                            {this.state.wrongAnswers.length ? this.state.wrongAnswers.map((item, index) =>
                                <div className='m-4 '>
                                    {/* <div className='text-right mb-1 mt-6'><span className='count-text'><b>{item.users.length}</b> Students got following Questions wrong</span></div> */}

                                    <div className='mb-1 mt-6'><span className='count-text'><b>{item.percentage}%</b> of Students got following Questions wrong</span> <span className='view-students ml-3 cursor-pointer' onClick={() => this.viewStudents(item)}>VIEW STUDENTS</span></div>

                                    <div className='question-container' style={{ background: "#F6F7F5" }}>
                                        {item.questions.map((question, qnIndex) =>
                                            // this.createElementFromHTML(question.content.title)
                                            <div className='row  p-4' >
                                                <div className='col-1'>{`${qnIndex + 1}.`}</div>
                                                <div className='col-11'>
                                                    <CwContentViewer content={question.content.title} />
                                                    {question.content.images && question.content.images.length ? question.content.images.map((image, imageIndex) =>
                                                        <img className='image-container mb-4 mr-3' src={image.imageUrl} alt="" />
                                                    )
                                                        :
                                                        ""}
                                                    {this.state.showOptions && this.renderContentType(question.content.type, question)}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            )
                                :
                                <div className='mt-2'>
                                    <div className='text-center'>No records Found</div>
                                </div>
                            }
                        </div>

                    </div>

        </>
        );
    }
}

export default AddContactComponent;